export const navigation = [
  { label: 'Méthode', to: '/methode' },
  { label: 'Cours de violoncelle', to: '/cours' },
  { label: 'Ateliers & stages', to: '/ateliers' },
  { label: 'Santé du musicien', to: '/sante-du-musicien' },
  { label: 'À propos', to: '/a-propos' },
]

export const contact = {
  email: 'contact@elisabetecosta.fr',
  portrait: 'https://cdn.magicpatterns.com/uploads/vqSnvwmtmzvvFBWjmxyCuL/1567594.webp',
  workshopImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/418a8dee-21f4-4372-989a-3bf89b180d1f.jpg',
}
